import type { NoticeListItem } from '@/api/model/noticeType'

export const countUnreadNoticesCnt = (notices: NoticeListItem[]) => {
  return notices.filter(notice => !notice.is_read).length
}
